import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/plazosvencimientos';

import Select from 'react-select';

import {api} from '../../actions/_request';


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



class PlazosModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            impuesto: {
                id:0,               
               cc1:0,
               cc2:0,
               cc3:0,
               cc4:0,
               cc5:0,
               cc6:0,
               cp1:0,
               cp2:0,
               cp3:0,
               cp4:0,
               cp5:0,
               cp6:0,           
            },
            action: 'save',
            activeTab: '1',
            modal:false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
                 
    }
   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

      componentWillReceiveProps(nextProps)
    {
           let self = this;
            api().get(`plazos_vencimientos/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        impuesto: response.data,
                        action: 'update'
                    });

                }

            });
    }

    componentDidMount()
    {
            let self = this;
            api().get(`plazos_vencimientos/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        impuesto: response.data,
                        action: 'update'
                    });

                }

            });
        
       
    }

   

    resetModal(){
        this.setState({
            impuesto: {
                 id:0,               
               cc1:0,
               cc2:0,
               cc3:0,
               cc4:0,
               cc5:0,
               cc6:0,
               cp1:0,
               cp2:0,
               cp3:0,
               cp4:0,
               cp5:0,
               cp6:0,             
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    



    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        impuesto[name] = value;
     
        this.setState({
            impuesto : impuesto
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {impuesto} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;        
        
            // let check = ['nombre','folio'];

            // for(let i in check) {

            // let key = check[i];

            // let value = impuesto[key];
            // dato=key;

            // if(value == '' || value == null){
            //     save = false;
            //     break;
            // }
                
            // }       
             
           
              
        // impuesto=this.objeto_mayusculas(impuesto);
       



        if(save){

            

              
                        this.props[action](impuesto, (data) => {
                        swal({
                            title: 'Plazos',
                            text: 'Plazos Guardados correctamente!',
                            type: 'success',
                            // showCancelButton: true,
                            // confirmButtonColor: '#3085d6',
                            // cancelButtonColor: '#d33',
                            confirmButtonText: 'Continue!'
                        }).then((result) => {
                            if (result.value) {
                              
                               
                               
                                self.props.toggle();
                                self.resetModal();
                            }
                        })
                    });

                
            

           


         

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render()
    {

        let {impuesto}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>Plazos de Vencimientos</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Plazos
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                          <div className="col-md-12 text-center">
                          <h3> Cuentas por Cobrar</h3>
                          </div>
                          <div className="col-md-6 text-center">
                          <label className='titulo_plazos' >Plazo en dias en Documentos por </label>
                          </div>
                         <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc1"
                                    maxLength={10}
                                    value={impuesto.cc1}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc2"
                                    maxLength={10}
                                    value={impuesto.cc2}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc3"
                                    maxLength={10}
                                    value={impuesto.cc3}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-6 text-center">
                        <label className='titulo_plazos' >Plazo en dias en Documentos </label>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc4"
                                    maxLength={10}
                                    value={impuesto.cc4}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc5"
                                    maxLength={10}
                                    value={impuesto.cc5}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cc6"
                                    maxLength={10}
                                    value={impuesto.cc6}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>                
                                       
                    </div> 
                     <div className="row mt-3 form_cliente">
                          <div className="col-md-12 text-center">
                          <h3> Cuentas por Pagar</h3>
                          </div>
                          <div className="col-md-6 text-center">
                          <label className='titulo_plazos' >Plazo en dias en Documentos por </label>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp1"
                                    maxLength={10}
                                    value={impuesto.cp1}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp2"
                                    maxLength={10}
                                    value={impuesto.cp2}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp3"
                                    maxLength={10}
                                    value={impuesto.cp3}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-6 text-center">
                        <label className='titulo_plazos' >Plazo en dias en Documentos </label>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp4"
                                    maxLength={10}
                                    value={impuesto.cp4}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp5"
                                    maxLength={10}
                                    value={impuesto.cp5}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cp6"
                                    maxLength={10}
                                    value={impuesto.cp6}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>                    
                    </div>                          
                          </Col>
                        </Row>
                      </TabPane>                      
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.plazosvencimientos.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        plazosvencimientos : state.plazosvencimientos,
    }
};

export default connect(mapStateToProps, actions)(PlazosModal)


// WEBPACK FOOTER //
// ./src/components/plazosvencimientos/modal.js